import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InstructionsMasterCreateRequestDTO, InstructionsMasterDTO, InstructionsMasterUpdateRequestDTO, InstructionsMasterDeleteRequestDTO, InstructionsMasterList, InstructionsMasterReadByIdRequestDTO, InstructionsMasterReadByMasterIdRequestDTO } from './instructions.interface';
import { InstructionsMaster_Create, InstructionsMaster_Delete, InstructionsMaster_ReadById, InstructionsMaster_ReadByMasterId, InstructionsMaster_Update } from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class InstructionsService {

  constructor() { }

  http = inject(HttpClient);

  InstructionsMaster_Create(data: InstructionsMasterCreateRequestDTO): Observable<InstructionsMasterDTO> {
    return this.http.post<InstructionsMasterDTO>(InstructionsMaster_Create, data);

  }

  InstructionsMaster_Update(data: InstructionsMasterUpdateRequestDTO): Observable<InstructionsMasterDTO> {
    return this.http.post<InstructionsMasterDTO>(InstructionsMaster_Update, data);
  }

  InstructionsMaster_Delete(data: InstructionsMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(InstructionsMaster_Delete, data);
  }

  

  InstructionsMaster_ReadById(data: InstructionsMasterReadByIdRequestDTO): Observable<InstructionsMasterList> {
    return this.http.post<InstructionsMasterList>(InstructionsMaster_ReadById, data);
  }

  InstructionsMaster_ReadByMasterId(data: InstructionsMasterReadByMasterIdRequestDTO): Observable<InstructionsMasterList> {
    return this.http.post<InstructionsMasterList>(InstructionsMaster_ReadByMasterId, data);
  }

}
